module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Yeti-b5683951db63439c90238a5ae1fd19c7.png";